import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { HowItWorks } from "@/components/HowItWorks";
import { Features } from "@/components/Features";
import { MeetBast } from "@/components/MeetBast";
import { Support } from "@/components/Support";
import { PrivacyPolicy } from "@/components/PrivacyPolicy";
import { Footer } from "@/components/Footer";

export default function Landing() {
  return (
    <div className="relative">
      <Navbar />
      <main>
        <Hero />
        <HowItWorks />
        <Features />
        <MeetBast />
        <Support />
        <PrivacyPolicy />
      </main>
      <Footer />
    </div>
  );
}
